module.exports = __webpack_public_path__ + "static/media/MC4.1db73657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/MC/MC4.png
// module id = 696
// module chunks = 0